export const environment = {
    BUILD_PRODUCT: "restaurant",
    API_URL_BASE: "https://api.12082026.xyz/",
    PRODUCT_URLS: {
        LANDING_PAGE: "https://12082026.xyz",
        USER_APP: "https://app.12082026.xyz",
        DRIVER: "https://driver.12082026.xyz",
        ADMIN: "https://admin.12082026.xyz",
        ACCOUNT: "https://account.12082026.xyz",
        ACCOUNT_REGISTRATION: "https://account.12082026.xyz/register"
    },
    URL_ALLERGEN_EXTERNAL: "https://www.wko.at/oe/tourismus-freizeitwirtschaft/gastronomie/allergeninfos-english",
    API_USER_SELF: "v1/users/self",
    API_RESTAURANT_CREATE: "v1/restaurants",
    API_RESTAURANT_INFO: "v1/restaurants/my",
    API_GET_MENU: "v1/restaurants/my/menu",
    API_GET_MENU_CATEGORY_LIST: "v1/restaurants/my/menu-category",
    API_GET_MENU_PRODUCTS_LIST: "v1/restaurants/my/products",
    API_GET_MENU_ADDON_LIST: "v1/restaurants/my/addongroup",
    API_UPLOAD_FILE: "v1/blob/upload",
    API_POST_REQUEST_VERIFICATION: "v1/restaurants/my/request-verification",
    API_GET_POST_KITCHEN_INVITATION: "v1/restaurants/my/kitchen-invitation",
    API_GET_DELETE_KITCHEN_INVITATION: "v1/restaurants/my/kitchen-invitation/{kitchenInvitationId}",
    API_POST_REGISTER_INVITATION: "v1/users/register-invitation",
    API_GET_TEAM_USERS_LIST: "v1/restaurants/my/team-users",
    API_GET_DELETE_TEAM_USER: "v1/restaurants/my/team-users/{userId}",
    API_GET_PUBLIC_KITCHEN_INVITATION: "v1/public/invitations/kitchen/{id}",
    API_GET_ORDERS_LIST: "v1/restaurants/my/orders",
    API_GET_INDIVIDUAL_ORDER: "v1/restaurants/my/orders/{orderId}",
    API_GET_ORDERS_SET_STATUS: "v1/restaurants/my/orders/{orderId}/status",
    API_POST_STRIPE_CREATE_ACCOUNT: "v1/restaurants/my/stripe-account",
    API_POST_STRIPE_CREATE_ACCOUNT_SESSION: "v1/restaurants/my/stripe-account-session",
    API_GET_RESTAURANT_FINANCIAL_STATUS: "v1/restaurants/my/financial",
    STRIPE_PUBLISHABLE_KEY: "pk_test_51PdTiERrbKJHrpRQ8aEqhK0vQJT9Z7a8cbzzQ6g7fapFnMnwJdzz5HuCwYPFanl4AqjN2I44GxBXJGAByLPxcTgv00Jrbc9E26",
    API_GET_ORDERS_REVIEWS: "v1/restaurants/my/orders/reviews",
    API_GET_RESTAURANT_DASHBOARD: 'v1/restaurants/my/dashboard',
    DEBUG_STAGING_BADGE: true
};
